import React, { useState, useEffect } from "react";
import useLoginSubmit from "../../../hooks/useLoginSubmit";
import useIsMobile from "../../../hooks/useIsMobile";

const SignInComponent = () => {
  const { register, handleSubmit, errors, loading, setValue } =
    useLoginSubmit();
  const [showPassword, setShowPassword] = useState(false);

  const isMobile = useIsMobile();

  useEffect(() => {
    // get username and mode from url params
    const urlParams = new URLSearchParams(window.location.search);
    const email = urlParams.get("email");
    const mode = urlParams.get("mode");
    console.log("email", email);
    // console.log("mode", mode);
    if (email && mode) {
      setValue("email", email);
    }
  }, []);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const Spinner = () => (
    <svg
      className="animate-spin h-5 w-5 text-green-secondary mx-auto"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      ></circle>
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
  );

  return (
    <div
      className={`w-full lg:w-1/2 px-4 sm:px-6 lg:px-8 py-6 sm:py-8 md:py-12 lg:py-16 h-auto lg:h-full overflow-y-auto bg-[#020617] relative ${
        isMobile ? "h-full" : "lg:h-full"
      }`}
    >
      <div className="max-w-md mx-auto lg:mx-0">
        <div className="flex flex-col items-start mb-5 sm:mb-6 md:mb-8">
          <h2 className="text-xl sm:text-xl lg:text-2xl font-bold text-[#ffffff] mb-2 sm:mb-3 md:mb-4">
            Log in to your admin panel
          </h2>
          <p className="w-full font-montserrat font-medium text-sm sm:text-base leading-5 sm:leading-6 text-white">
            Everything you need to run your meetings and grow your projects.
          </p>
        </div>
        <div className="flex flex-col items-start mb-4 sm:mb-6 md:mb-8 pb-16 sm:pb-20 lg:pb-0">
          <form className="w-full" onSubmit={handleSubmit} noValidate>
            <div className="flex flex-col space-y-4 sm:space-y-5 md:space-y-6">
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-300 mb-2"
                >
                  Email Address
                </label>
                <input
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value: /\S+@\S+\.\S+/,
                      message: "Email is not a valid email",
                    },
                  })}
                  type="email"
                  id="email"
                  placeholder="Email Address"
                  className="w-full px-3 py-2.5 sm:py-3 bg-white border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#1CD760] focus:border-transparent"
                />
                {errors.email &&
                  (String(errors.email.message)
                    .toLowerCase()
                    .indexOf("incorrect") !== -1 ? (
                    <p className="text-sm text-red-500 mt-2">
                      Uh-oh! Your email or password is incorrect. No worries —
                      you can reset it{" "}
                      <a
                        href="https://account.r-link.com/reset-password"
                        className="text-blue-500 hover:underline"
                      >
                        here
                      </a>
                    </p>
                  ) : (
                    <p className="text-sm text-red-500 mt-2">
                      {errors.email.message}
                    </p>
                  ))}
              </div>
              <div>
                <label
                  htmlFor="password"
                  className="block text-sm font-medium text-gray-300 mb-2"
                >
                  Password
                </label>
                <div className="relative">
                  <input
                    {...register("password", {
                      required: "Password is required",
                      minLength: {
                        value: 5,
                        message: "Password must be at least 5 characters",
                      },
                    })}
                    type={showPassword ? "text" : "password"}
                    id="password"
                    placeholder="Password"
                    className="w-full px-3 py-2.5 sm:py-3 pr-12 bg-white border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#1CD760] focus:border-transparent"
                  />
                  <button
                    type="button"
                    onClick={togglePasswordVisibility}
                    className="absolute inset-y-0 right-0 px-3 flex items-center text-gray-500 hover:text-gray-700"
                    aria-label={
                      showPassword ? "Hide password" : "Show password"
                    }
                  >
                    {showPassword ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="h-5 w-5"
                      >
                        <path d="M2.458 12C3.732 7.943 7.523 5 12 5s8.268 2.943 9.542 7c-1.274 4.057-5.065 7-9.542 7s-8.268-2.943-9.542-7z" />
                        <circle cx="12" cy="12" r="3" />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="h-5 w-5"
                      >
                        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                        <line x1="1" y1="1" x2="23" y2="23" />
                      </svg>
                    )}
                  </button>
                </div>
                {errors.password && (
                  <p className="text-sm text-red-500 mt-2">
                    {errors.password.message}
                  </p>
                )}
              </div>

              <div className="flex justify-center flex-col items-center mt-5 sm:mt-6">
                <button
                  type="submit"
                  className="w-full max-w-sm bg-[#1CD760] rounded-full hover:bg-green-primary text-white font-semibold text-sm sm:text-base py-2.5 sm:py-3 md:py-4 transition-colors duration-200 disabled:opacity-60 flex items-center justify-center"
                  disabled={loading}
                >
                  {loading ? <Spinner /> : "Continue"}
                </button>
                <div className="flex flex-row justify-between text-sm mt-3 sm:mt-4 w-full max-w-sm">
                  <div className="flex w-full justify-between items-center flex-wrap gap-2">
                    <div className="flex items-center">
                      <input
                        {...register("rememberMe")}
                        type="checkbox"
                        id="rememberMe"
                        className="h-4 w-4 text-blue-primary border-gray-300 rounded focus:ring-blue-primary"
                      />
                      <span className="ml-2 text-[#ffffff] opacity-60 text-xs sm:text-sm">
                        Remember me
                      </span>
                    </div>
                    <div className="flex items-center">
                      <a
                        href="https://account.r-link.com/reset-password"
                        className="text-[#4b59c9] hover:underline text-xs sm:text-sm whitespace-nowrap"
                      >
                        Forgot password?
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              {/* Submit error display */}
              {errors.submit && (
                <div className="text-center mt-4">
                  <p className="text-red-500 text-sm">
                    {errors.submit.message}
                  </p>
                </div>
              )}
            </div>
          </form>

          {/* R-Link Email Support */}
          <div className="absolute bottom-4 sm:bottom-6 lg:bottom-8 left-1/2 -translate-x-1/2 lg:left-1/2 lg:-translate-x-1/2 flex flex-col items-center justify-center w-full px-4 sm:px-0">
            <p className="text-[#ffffff] opacity-60 text-xs text-center">
              R-Link Email Support:
              <br className="hidden sm:block" />{" "}
              <span className="sm:hidden"> </span>support@r-link.com
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignInComponent;
